<template>
  <header class="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-ink/5">
    <div class="container-custom">
      <div class="flex justify-between items-center h-20">
        <!-- Logo -->
        <a href="#top" class="flex items-center group" @click="closeMobileMenu">
          <img
            :src="logoColor"
            alt="Kettelsen"
            class="h-8 sm:h-9 w-auto transition-transform duration-200 group-hover:scale-105"
          />
        </a>

        <!-- Desktop Navigation -->
        <nav class="hidden md:flex items-center gap-8">
          <a
            v-for="link in links"
            :key="link.href"
            :href="link.href"
            class="text-ink/70 hover:text-kettelsen font-semibold text-sm transition-colors duration-200"
          >
            {{ $t(link.label) }}
          </a>
          <div class="pl-2">
            <LanguageSwitcher />
          </div>
          <a href="#contact" class="btn-primary text-sm">
            {{ $t('nav.book') }}
          </a>
        </nav>

        <!-- Mobile controls -->
        <div class="flex items-center gap-3 md:hidden">
          <LanguageSwitcher />
          <button
            @click="toggleMobileMenu"
            class="text-ink hover:text-kettelsen focus:outline-none transition-colors duration-200"
            :aria-label="mobileMenuOpen ? 'Close menu' : 'Open menu'"
          >
            <svg v-if="!mobileMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile Navigation -->
      <div v-if="mobileMenuOpen" class="md:hidden pb-4 border-t border-ink/5">
        <nav class="flex flex-col space-y-1 pt-3">
          <a
            v-for="link in links"
            :key="link.href"
            :href="link.href"
            class="text-ink/80 hover:text-kettelsen font-semibold py-2 transition-colors duration-200"
            @click="closeMobileMenu"
          >
            {{ $t(link.label) }}
          </a>
          <a href="#contact" class="btn-primary mt-3 w-full" @click="closeMobileMenu">
            {{ $t('nav.book') }}
          </a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue'
import logoColor from '@/assets/logo-color.png'

export default {
  name: 'NavBar',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      logoColor,
      mobileMenuOpen: false,
      links: [
        { href: '#services', label: 'nav.services' },
        { href: '#process', label: 'nav.process' },
        { href: '#why', label: 'nav.why' }
      ]
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    }
  }
}
</script>
